// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* These colors are supposed to by dynamuc during the runtime */\n/* Please, don't plase the static color here, if they are not supposed to be changed in runtime */\n.rtb-border-radius {\n  border-radius: 8px;\n}\n.rtb-border {\n  border: solid 3px var(--primary-accent-color);\n}\n.rtb-box-shadow {\n  -webkit-box-shadow: 0 0 3px rgba(0, 0, 0, 0.5);\n          box-shadow: 0 0 3px rgba(0, 0, 0, 0.5);\n}\n.pre-game-all-users {\n  margin-right: 10px;\n  margin-left: 10px;\n}", ""]);
// Exports
module.exports = exports;
